import PresenterSidePanelMenu from './PresenterSidePanelMenu'
import { connect } from 'react-redux'
import { PresenterSidePanelMenuProps } from './types'
import { State } from '../../dataStore/reducers/reducerType'
import { openSidePanel, closeSidePanel, setSelectedMenuItem } from '../../dataStore/actions/ui/uiActions'
import { SidePanelTypes } from '@bt-react/constants'

type Dispatch = 'openSidePanel' | 'closeSidePanel' | 'setSelectedMenuItem'

const mapStateToProps = (state: State): Omit<PresenterSidePanelMenuProps, Dispatch> => ({
  debug: state.config.debug,
  isSidePanelOpen: state.ui.isSidePanelOpen,
  featureFlags: state.config.featureFlags
})

const mapDispatchToProps = (dispatch): Pick<PresenterSidePanelMenuProps, Dispatch> => ({
  openSidePanel: () => dispatch(openSidePanel()),
  closeSidePanel: () => dispatch(closeSidePanel()),
  setSelectedMenuItem: (item: SidePanelTypes) => dispatch(setSelectedMenuItem(item))
})

export default connect(mapStateToProps, mapDispatchToProps)(PresenterSidePanelMenu)
